import DOMPurify from 'dompurify';

/**
 * Titolo della pagina dei turni: «Turni della <nome farmacia>», oppure solo «Turni» se il nome manca.
 *
 * @param {?string} shopName nome della farmacia (opzione `shop_name`)
 * @returns {string}
 */
export const shiftsTitle = (shopName) => {
  const name = typeof shopName === 'string' ? shopName.trim() : '';

  return name ? `Turni della ${name}` : 'Turni';
};

/**
 * Testo dei turni pronto da mostrare: senza script né gestori di eventi, con i link che si aprono fuori
 * dalla pagina (nella webview un link senza target porterebbe via l'utente dall'app).
 *
 * @param {?string} html testo formattato scritto nel dash
 * @returns {string}
 */
export const sanitizeShiftsHtml = (html) => {
  if (!html) return '';

  const template = document.createElement('template');

  template.innerHTML = DOMPurify.sanitize(html);

  template.content.querySelectorAll('a[href]').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });

  return template.innerHTML;
};
